import { createTheme } from '@mui/material/styles';

export function getFreeAppTheme() {
  return createTheme({
    typography: {
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      h1: { fontFamily: '"Manrope", sans-serif', fontWeight: 700, letterSpacing: '-0.025em' },
      h2: { fontFamily: '"Manrope", sans-serif', fontWeight: 700, letterSpacing: '-0.025em' },
      h3: { fontFamily: '"Manrope", sans-serif', fontWeight: 600, letterSpacing: '-0.02em' },
      h4: { fontFamily: '"Manrope", sans-serif', fontWeight: 600, letterSpacing: '-0.02em' },
      h5: { fontFamily: '"Manrope", sans-serif', fontWeight: 600 },
      h6: { fontFamily: '"Manrope", sans-serif', fontWeight: 600 },
      subtitle1: { fontWeight: 500 },
      subtitle2: { fontWeight: 500 },
      button: { textTransform: 'none', fontWeight: 500 },
    },
    palette: {
      mode: 'light',
      primary: { main: '#183B66', dark: '#102844', light: '#2E5C8A', contrastText: '#FFFFFF' },
      secondary: { main: '#16B8A6', dark: '#0E9C8C', contrastText: '#FFFFFF' },
      background: { default: '#F8FAFC', paper: '#FFFFFF' },
      text: { primary: '#111827', secondary: '#64748B' },
      divider: '#E2E8F0',
      error: { main: '#DC2626' },
      warning: { main: '#D97706' },
      success: { main: '#16B8A6' },
      info: { main: '#183B66' },
    },
    shape: { borderRadius: 12 },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: { backgroundColor: '#F8FAFC' },
        },
      },
      MuiButton: {
        defaultProps: { disableElevation: true },
        styleOverrides: {
          root: { borderRadius: 12, textTransform: 'none', fontWeight: 500, boxShadow: 'none' },
          containedPrimary: {
            '&:hover': { backgroundColor: '#102844', boxShadow: 'none' },
          },
          outlined: {
            borderColor: '#E2E8F0',
            '&:hover': { borderColor: '#CBD5E1', backgroundColor: '#F1F5F9' },
          },
          text: {
            '&:hover': { backgroundColor: '#F1F5F9' },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            border: '1px solid #E2E8F0',
            boxShadow: '0 1px 2px rgba(16, 40, 68, 0.04)',
          },
        },
      },
      MuiPaper: {
        defaultProps: { elevation: 0 },
        styleOverrides: {
          root: { backgroundImage: 'none' },
          outlined: { border: '1px solid #E2E8F0' },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            backgroundColor: '#FFFFFF',
            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#CBD5E1' },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#183B66', borderWidth: 1 },
          },
          notchedOutline: { borderColor: '#E2E8F0' },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: { color: '#64748B', '&.Mui-focused': { color: '#183B66' } },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            fontWeight: 500,
            minHeight: 48,
            color: '#64748B',
            '&.Mui-selected': { color: '#183B66', fontWeight: 600 },
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          indicator: { backgroundColor: '#183B66', height: 2 },
          root: { borderBottom: '1px solid #E2E8F0' },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: { borderRadius: 8, fontWeight: 500 },
          filled: { backgroundColor: '#F1F5F9', color: '#111827' },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            fontWeight: 600,
            backgroundColor: '#F1F5F9',
            color: '#64748B',
            fontSize: '0.75rem',
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            borderBottom: '1px solid #E2E8F0',
          },
          body: { borderBottom: '1px solid #E2E8F0', color: '#111827' },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            '&:hover': { backgroundColor: '#F8FAFC' },
            '&:last-child td': { borderBottom: 0 },
          },
        },
      },
      MuiAlert: {
        styleOverrides: {
          root: { borderRadius: 12 },
          standardInfo: { backgroundColor: '#F1F5F9', color: '#183B66' },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: { borderRadius: 12, border: '1px solid #E2E8F0' },
        },
      },
      MuiFab: {
        styleOverrides: {
          root: { boxShadow: '0 4px 24px rgba(16, 40, 68, 0.12)' },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: { borderRadius: 10 },
        },
      },
      MuiDivider: {
        styleOverrides: {
          root: { borderColor: '#E2E8F0' },
        },
      },
    },
  });
}
